var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_body"},[_c('Header'),_c('div',{staticClass:"_page"},[_c('div',{staticClass:"_content"},[_c('qyjbxx-1',{attrs:{"dwhcpd":_vm.dwhcpd}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }